import request from '@/utils/request'
//多网卡接口
//多网卡列表
export function cardMultiNetList(data){
  return request({
    url: '/card/multiNet/page',
    method: 'post',
    data: data
  })
}

//多网卡统计
export function cardMultiNetCount(data){
  return request({
    url: '/card/multiNet/selectCount',
    method: 'get',
    params: data
  })
}

//多网卡详情
export function cardMultiNetInfo(data){
  return request({
    url: '/card/multiNet/multiNetInfo',
    method: 'get',
    params: data
  })
}

//多网卡套餐列表
export function cardMultiNetProductList(data){
  return request({
    url: '/card/multiNet/multiNetProductList',
    method: 'get',
    params: data
  })
}

//多网卡订单列表
export function multiMultiNetOrderList(data){
  return request({
    url: '/card/multiNet/multiNetOrderList',
    method: 'get',
    params: data
  })
}

//多网卡操作记录
export function multiMultiNetOperationRecord(data){
  return request({
    url: '/card/multiNet/multiNetCardOperation',
    method: 'post',
    data: data
  })
}

//多网卡流量统计
export function lineChartMultiNetFlow(data){
  return request({
    url: '/card/multiNet/lineChartMultiNetFlow',
    method: 'get',
    params: data
  })
}

//多网卡解绑
export function unpackCardMultiCard(data){
  return request({
    url: '/card/multiNet/unpackCardMultiCard',
    method: 'get',
    params: data
  })
}

//多网卡批量解绑
export function batchUnpackCardMultiCard(data){
  return request({
    url: '/card/multiNet/batchUnpackCardMultiCard',
    method: 'post',
    data: data
  })
}

//根据组网号查询多网卡详情
export function selectMultiNetByGroupNos(data){
  return request({
    url: '/card/multiNet/selectByGroupNos',
    method: 'post',
    data: data
  })
}

//组网批量换卡
export function batchSwitchMultiNetCard(data){
  return request({
    url: '/card/multiNet/batchSwitchMultiNetCard',
    method: 'post',
    data: data
  })
}

//根据组网号查询多网卡号
export function selectMultiNetCard(data){
  return request({
    url: '/card/multiNet/selectMultiNetCard',
    method: 'get',
    params: data
  })
}

//刷新多网卡号
export function refreshMultiNetCard(data){
  return request({
    url: '/card/multiNet/refreshMultiNetCard',
    method: 'get',
    params: data
  })
}

//停用多网卡
export function stopMultiNetCard(data){
  return request({
    url: '/card/multiNet/stopMultiNetCard',
    method: 'get',
    params: data
  })
}

//启用多网卡
export function openMultiNetCard(data){
  return request({
    url: '/card/multiNet/openMultiNetCard',
    method: 'get',
    params: data
  })
}

//导出多网卡
export function exportMultiNet(data){
  return request({
    url: '/card/multiNet/export',
    method: 'post',
    data: data
  })
}
//批量更新多网卡状态
export function batchUpdateMultiCardStatus(data){
  return request({
    url: '/card/multiNet/batchUpdateMultiCardStatus',
    method: 'post',
    data: data
  })
}

//多网卡操作记录
export function multiNetRecordPage(data){
  return request({
    url: '/card/multiNet/record/page',
    method: 'post',
    data: data
  })
}

//保存备注
export function saveRemark(data){
  return request({
    url: '/card/multiNet/saveRemark',
    method: 'post',
    data: data
  })
}

